export default {
    methods:{
        getCategoryColor(category){
            switch (category){
                case 'C#':
                    return "#277DA1";
                case 'Unity':
                    return "#577590";
                case 'Project Management':
                    return "#F94144";
                case 'Tools':
                    return "#F3722C";
                case '3D':
                    return "#43AA8B";
                case '2D':
                    return "#F9844A";
                case 'UE4':
                    return "#90BE6D";
                case 'Mobile':
                    return "#F9C74F";
                case 'WEB':
                    return "#F8961E";
                default: return "#4D4D4D";
            }
        }
    }
}